import PropTypes from 'prop-types';
import React from 'react';
import VideoPlayer from './VideoPlayer';
import AudioPlayer from './AudioPlayer';
import ImagePlayer from './ImagePlayer';

const MediaPlayer = ({
  project,
  zoom = true,
  staffPicks = true,
  user,
  onZoom,
  onLoad,
}) => {
  // Check if any streams exist, and if not default to image
  if (project) {
    if (project.mediaType === 'video') {
      return (
        <VideoPlayer
          project={project}
          staffPicks={staffPicks}
          user={user}
          onLoad={onLoad}
        />
      );
    }

    if (project.mediaType === 'audio') {
      return (
        <AudioPlayer
          project={project}
          staffPicks={staffPicks}
          user={user}
          onLoad={onLoad}
        />
      );
    }

    if (project.mediaType === 'image' || project.mediaType === 'other') {
      return (
        <ImagePlayer
          project={project}
          zoom={zoom}
          staffPicks={staffPicks}
          onZoom={onZoom}
          onLoad={onLoad}
          user={user}
        />
      );
    }
  }

  return <noscript />;
};

MediaPlayer.propTypes = {
  project: PropTypes.object,
  zoom: PropTypes.bool,
  staffPicks: PropTypes.bool,
};

export default MediaPlayer;
